<template>
  <div class="format">
    <h2 v-if="currentObject">Formatowanie</h2>
    <template v-if="currentObject">
      <el-row v-if="isTextBox" type="flex" justify="space-between" :gutter="0">
        <el-col :span="10">
          <el-button-group>
            <el-button :disabled="isBoldDisabled" @click="setBold" :type="isBold ? 'primary' : ''" size="mini"><i class="fas fa-bold"></i></el-button>
            <el-button :disabled="isItalicDisabled" @click="setItalic" :type="isItalic ? 'primary' : ''" size="mini"><i class="fas fa-italic"></i></el-button>
            <el-button @click="setUnderline" :type="isUnderline ? 'primary' : ''" size="mini"><i class="fas fa-underline"></i></el-button>
          </el-button-group>
        </el-col>
        <el-col :span="14">
          <el-button-group>
            <el-button @click="setAlign('left')" :type="currentObject.textAlign == 'left' ? 'primary' : ''" size="mini"><i class="fas fa-align-left"></i></el-button>
            <el-button @click="setAlign('center')" :type="currentObject.textAlign == 'center' ? 'primary' : ''"  size="mini"><i class="fas fa-align-center"></i></el-button>
            <el-button @click="setAlign('right')" :type="currentObject.textAlign == 'right' ? 'primary' : ''"  size="mini"><i class="fas fa-align-right"></i></el-button>
            <el-button @click="setAlign('justify')" :type="currentObject.textAlign == 'justify' ? 'primary' : ''"  size="mini"><i class="fas fa-align-justify"></i></el-button>
          </el-button-group>
        </el-col>
      </el-row>
      <el-divider v-if="isTextBox"></el-divider>
      <el-row v-if="isTextBox" :gutter="10">
        <el-col :span="4">
          Kolor
          <el-color-picker :value="getColor" @change="setColor" show-alpha></el-color-picker>
        </el-col>
        
        <el-col :span="20">
          Czcionka
          <el-select :value="getFontFamily" @change="setFontFamily" placeholder="Czcionka">
          <el-option
            v-for="font in fonts"
            :key="font.value"
            :label="font.label"
            :value="font.value">
            <img style="margin-top: -3px" height="40" :src="`/img/fonts/${font.preview}`" :alt="font.label" />
          </el-option>
        </el-select>
        </el-col>
      </el-row>
      <el-divider v-if="isTextBox"></el-divider>
      <el-row v-if="isTextBox" type="flex" justify="space-between" :gutter="10">
        <el-col>Rozmiar <br />
        <el-input-number @change="setFontSize" :value="getFontSize" :min="1" size="mini"></el-input-number></el-col>
        <el-col>Interlinia <br /><el-input-number @change="setLineHeight" v-model="currentObject.lineHeight" :precision="2" :step="0.01" :min="0" size="mini"></el-input-number></el-col>
      </el-row>

      <el-row class="hideonmobile" v-if="isTextBox">
        Odstęp między znakami <br />
        <el-input-number :value="getCharSpacing" @change="setCharSpacing" size="mini"></el-input-number>
      </el-row>
      <el-divider class="hideonmobile" v-if="isTextBox"></el-divider>
      <el-row class="hideonmobile" type="flex" justify="space-between" :gutter="10">
        <el-col>Pozycja X<br /><el-input-number @change="setLeft" v-model="currentObject.left" size="mini"></el-input-number></el-col>
        <el-col>Pozycja Y<br /><el-input-number @change="setTop" v-model="currentObject.top" size="mini"></el-input-number></el-col>
      </el-row>
      <el-row class="hideonmobile" type="flex" justify="space-between" :gutter="10">
        <el-col>Obrót<br /><el-input-number @change="setAngle" v-model="currentObject.angle" size="mini"></el-input-number></el-col>
        <el-col v-if="isTextBox">Skala<br /><el-input-number @change="setScale" :step="0.01" v-model="currentObject.scaleX" size="mini"></el-input-number></el-col>
      </el-row>
      <el-divider class="hideonmobile"></el-divider>
      <el-row type="flex" justify="space-between" :gutter="0">
        <el-col :span="13">
          Położenie X
          <el-button-group>
            <el-button @click="setAlignElement('left')" size="mini"><i class="fas fa-align-left"></i></el-button>
            <el-button @click="setAlignElement('center')" size="mini"><i class="fas fa-align-center"></i></el-button>
            <el-button @click="setAlignElement('right')" size="mini"><i class="fas fa-align-right"></i></el-button>
          </el-button-group>
        </el-col>
        <el-col :span="12">
          Położenie Y
          <el-button-group>
            <el-button @click="setAlignElement('top')" size="mini"><i class="fas fa-align-left"></i></el-button>
            <el-button @click="setAlignElement('middle')" size="mini"><i class="fas fa-align-center"></i></el-button>
            <el-button @click="setAlignElement('bottom')" size="mini"><i class="fas fa-align-right"></i></el-button>
          </el-button-group>
        </el-col>
      </el-row>
    </template>
    <el-divider class="bottom" v-if="currentObject"></el-divider>
    <layers v-if="loggedIn"/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Fonts from '../../classes/Fonts';
  import Editor from '../../classes/Editor';
  import Layers from './Layers.vue'

  export default {
    data() {
      return {
        fonts: Fonts.getAvailable(),
        currentObject: null,
        selectionStyles: null
      }
    },
    computed: {
      ...mapGetters('user', [
        'loggedIn',
      ]),
      ...mapGetters('creator', [
        'project',
        'activeScene',
      ]),
      fontConfig() {
        return Fonts.getFontConfig(this.getFontFamily)
      },
      isBoldDisabled() {
        return this.isItalic ? !this.fontConfig.boldItalic : !this.fontConfig.bold 
      },
      isItalicDisabled() {
        return this.isBold ? !this.fontConfig.boldItalic : !this.fontConfig.italic
      },
      isTextBox() {
        return this.currentObject.type == 'textbox'
      },
      isImage() {
        return this.currentObject.type == 'image'
      },
      isBold() {
        if (this.selectionStyles && this.selectionStyles.length) {
          return this.selectionStyles.every((letter) => letter['fontWeight'] == 'bold')
        }

        return this.currentObject.fontWeight == 'bold'
      },
      isItalic() {
        if (this.selectionStyles && this.selectionStyles.length) {
          return this.selectionStyles.every((letter) => letter['fontStyle'] == 'italic')
        }

        return this.currentObject.fontStyle == 'italic'
      },
      isUnderline() {
        if (this.selectionStyles && this.selectionStyles.length) {
          return this.selectionStyles.every((letter) => letter['underline'] == true)
        }

        return this.currentObject.underline == true
      },
      getColor() {
        if (this.selectionStyles && this.selectionStyles.length) {
          return this.selectionStyles[0].fill || this.currentObject.fill
        }

        return this.currentObject.fill
      },
      getFontSize() {
        // If selected text exist then return a fontSize for this selection
        if (this.selectionStyles && this.selectionStyles.length && this.selectionStyles[0].fontSize) {
          return this.selectionStyles[0].fontSize;
        }

        const fontSizes = [];
        const styles = Object.values(this.currentObject.styles);

        if (styles.length) {
          styles.forEach((row) => Object.values(row).forEach((item) => {
            if (item.fontSize || false) {
              fontSizes.push(item.fontSize)
            }
          }));
        }

        const uniqueFontSize = [...new Set(fontSizes)];

        // Every letter of text has the same fontSize then return that font size
        if (fontSizes.length === this.currentObject.text.length && uniqueFontSize.length === 1) {
          return uniqueFontSize[0];
        }

        // If the text has more the one unique fontSize or
        // we found only one unique fontSize and is different then fontSize from box
        // then we return maximum
        if (uniqueFontSize.length > 1 || (uniqueFontSize.length === 1 && uniqueFontSize[0] != this.currentObject.fontSize)) {
          uniqueFontSize.push(this.currentObject.fontSize);
          return Math.max(...uniqueFontSize);
        }

        // Return the font from box
        return this.currentObject.fontSize;
      },
      getFontFamily() {
        // If selected text exist then return a fontFamily for this selection
        if (this.selectionStyles && this.selectionStyles.length) {
          return this.selectionStyles[0].fontFamily || this.currentObject.fontFamily;
        }

        const fontNames = [];
        const styles = Object.values(this.currentObject.styles);

        if (styles.length) {
          styles.forEach((row) => Object.values(row).forEach((item) => {
            if (item.fontFamily || false) {
              fontNames.push(item.fontFamily)
            }
          }));
        }

        const uniqueFontName = [...new Set(fontNames)];

        // Every letter of text has the same fontFamily then return that font name
        if (fontNames.length === this.currentObject.text.length && uniqueFontName.length === 1) {
          return uniqueFontName[0];
        }

        // If the text has more the one unique fontFamily or
        // we found only one unique font and is different then font from box
        // then we don't know font name
        if (uniqueFontName.length > 1 || (uniqueFontName.length === 1 && uniqueFontName[0] != this.currentObject.fontFamily)) {
          return '';
        }

        // Return the font from box
        return this.currentObject.fontFamily;
      },
      getCharSpacing() {
        console.log('get getCharSpacing');
        if (this.selectionStyles && this.selectionStyles.length) {
          console.log('selection getCharSpacing');
          return this.selectionStyles[0].charSpacing || this.currentObject.charSpacing
        }

          console.log('global getCharSpacing');
        return this.currentObject.charSpacing
      }
    },
    mounted() {

      Editor.addCallback('selection:created', () => {
        this.currentObject = Editor.canvas.getActiveObject()
      })
      
      Editor.addCallback('selection:updated', () => {
        this.currentObject = Editor.canvas.getActiveObject()
      })   

      Editor.addCallback('selection:cleared', () => {
        this.currentObject = null
        this.selectionStyles = []
        console.log('right selection cleared')
      })

      Editor.addCallback('text:selection:changed', () => {
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles()
        console.log('right text:selection:changed')
      })
    },
    methods: {
      printInfromation() {
        const showPrintInfromation = !localStorage.printInfromation;
        if (showPrintInfromation) {
          this.$alert('Zmieniając kolor należy mieć na uwadze, że ostateczny kolor może się nieznacznie różnić od wybranego, ponieważ zależy to od rodzaju i ustawień monitora.', 'Uwaga!', {
            confirmButtonText: 'OK',
            type: 'warning',
          });

          localStorage.printInfromation = true;
        }
      },
      setBold() {
        Editor.setStyleForActiveObject('fontWeight', 'bold');
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles();
      },
      setItalic() {
        Editor.setStyleForActiveObject('fontStyle', 'italic');
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles();
      },
      setUnderline() {
        Editor.setStyleForActiveObject('underline', true);
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles();
      },
      setAlign(direction) {
        Editor.setStyleForActiveObject('textAlign', direction, false, false);
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles();
      },
      setAlignElement(direction) {
        const realObjectWidth = this.currentObject.width / this.currentObject.scaleX
        const realObjectHeight = this.currentObject.height / this.currentObject.scaleY

        switch (direction) {
          case 'right':
            Editor.setStyleForActiveObject('left', Editor.width - realObjectWidth, false, false);
            break;
          case 'center':
            Editor.setStyleForActiveObject('left', (Editor.width - realObjectWidth) / 2, false, false);
            break;
          case 'left':
            Editor.setStyleForActiveObject('left', 0, false, false);
            break;
          case 'top':
            Editor.setStyleForActiveObject('top', 0, false, false);
            break;
          case 'middle':
            Editor.setStyleForActiveObject('top', (Editor.height - realObjectHeight) / 2, false, false);
            break;
          case 'bottom':
            Editor.setStyleForActiveObject('top', Editor.height - realObjectHeight, false, false);
            break;
        }
      },
      setFontSize(fontSize) {
        Editor.setStyleForActiveObject('fontSize', fontSize, false);
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles();
      },
      incFontSize() {
        this.currentObject.fontSize = this.currentObject.fontSize + 1
        Editor.setStyleForActiveObject('fontSize', this.currentObject.fontSize, false);
      },
      decFontSize() {
        this.currentObject.fontSize = this.currentObject.fontSize - 1
        Editor.setStyleForActiveObject('fontSize', this.currentObject.fontSize, false);
      },
      setLineHeight() {
        Editor.setStyleForActiveObject('lineHeight', this.currentObject.lineHeight, false);
        // Editor.canvas.renderAll()
      },
      setLeft() {
        Editor.setStyleForActiveObject('left', this.currentObject.left, false, false);
      },
      setTop() {
        Editor.setStyleForActiveObject('top', this.currentObject.top, false, false);
      },
      setAngle() {
        Editor.setStyleForActiveObject('angle', this.currentObject.angle, false, false);
      },
      setScale(scale) {
        Editor.setStyleForActiveObject('scaleX', scale, false, false);
        Editor.setStyleForActiveObject('scaleY', scale, false, false);
      },
      setColor(color) {
        this.printInfromation();
        Editor.setStyleForActiveObject('fill', color, false);
      },
      setCharSpacing(charSpacing) {
        Editor.setStyleForActiveObject('charSpacing', charSpacing, false, false);
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles();
      },
      setFontFamily(fontFamily) {
        if (['Times New Roman', 'Arial'].includes(fontFamily)) {
          Editor.setStyleForActiveObject('fontFamily', fontFamily, false);
          this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles();
        } else {
          this.loadAndUse(fontFamily);
        }

      },
      async loadAndUse(font) {

        await Fonts.load(font)

        Editor.setStyleForActiveObject('fontFamily', font, false);
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles();

        if (this.isBold && !this.fontConfig.bold) {
          this.setBold()
        }

        if (this.isItalic && !this.fontConfig.italic) {
          this.setItalic()
        }

        if (this.isItalic && this.isBold && !this.fontConfig.boldItalic) {
          this.setItalic()
        }
      }
    },
    components: {
      Layers
    }
  }
</script>

<style lang="less" scoped>
  .right {
    .el-divider {
      background-color: #eee;
      margin: 15px 0;
    }
    .el-select,
    .el-input-number,
    .el-color-picker,
    .el-button-group {
      margin-top: 8px;
    }
    .el-col,
    .el-row {
      font-size: 14px;
    }
    .el-row + .el-row {
      margin-top: 15px;
    }
  }
  .hideonmobile {
    @media (max-width: 767px) {
      display: none;
    }
  }

  .el-divider.bottom {
    margin-top: 25px;
  }
</style>